// Shared constants + helpers for the Progress page and its sub-components.
// Extracted from Progress.jsx to keep that file focused on layout/state.

export const VIEW_MODES = [
  { v: "week",  l: "أسبوع", tKey: "prog.tab_week"  },
  { v: "month", l: "شهر",   tKey: "prog.tab_month" },
  { v: "year",  l: "سنة",   tKey: "prog.tab_year"  },
];

export const AR_MONTHS_FULL = ["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];
export const EN_MONTHS_FULL = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
export const AR_DAYS = ["اثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت","أحد"];
export const EN_DAYS = ["Mon","Tue","Wed","Thu","Fri","Sat","Sun"];
export const AR_MONTHS_TIP = ["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوفمبر","ديسمبر"];

// Format ISO date for tooltip: "27 يوليو 2026" / "27 Jul 2026"
export function fmtIsoAr(iso, lang = "ar") {
  if (!iso) return "";
  const [y, m, d] = iso.split("-").map(Number);
  const months = lang === "en" ? EN_MONTHS_FULL : AR_MONTHS_TIP;
  return `${d} ${months[m - 1]} ${y}`;
}

// Contextual title for tooltips based on viewMode:
// - week  → "الاثنين · 27 يوليو"
// - month → "الأسبوع الثالث · 15 – 21 يوليو"
// - year  → "شهر يوليو 2026"
export function chartTooltipTitle(datum, viewMode, cursorYear, lang = "ar") {
  if (!datum) return "";
  if (viewMode === "week") {
    return `${datum.label} · ${fmtIsoAr(datum.date, lang)}`;
  }
  if (viewMode === "month") {
    return `${datum.label} · ${fmtIsoAr(datum.weekStart, lang)} — ${fmtIsoAr(datum.weekEnd, lang)}`;
  }
  const m = parseInt(datum.label);
  const months = lang === "en" ? EN_MONTHS_FULL : AR_MONTHS_TIP;
  return isNaN(m)
    ? datum.label
    : (lang === "en" ? `${months[m - 1]} ${cursorYear}` : `شهر ${months[m - 1]} ${cursorYear}`);
}

export function bmiCategory(bmi, lang = "ar") {
  const en = lang === "en";
  if (bmi < 18.5) return { l: en ? "Underweight"   : "نقص وزن",   color: "#38BDF8" };
  if (bmi < 25)   return { l: en ? "Normal weight" : "وزن طبيعي", color: "#22C55E" };
  if (bmi < 30)   return { l: en ? "Overweight"    : "وزن زائد",  color: "#F59E0B" };
  return              { l: en ? "Obese"          : "سمنة",       color: "#EF4444" };
}

// Returns a JS Date representing the Monday of the week for the given date
export function mondayOf(d) {
  const dt = new Date(d);
  dt.setHours(0, 0, 0, 0);
  const dow = dt.getDay(); // 0 Sun … 6 Sat
  const diff = (dow === 0 ? -6 : 1 - dow); // move to Monday
  dt.setDate(dt.getDate() + diff);
  return dt;
}

export function toISO(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${dd}`;
}

export function fmtDayShort(d, lang = "ar") {
  const months = lang === "en" ? EN_MONTHS_FULL : AR_MONTHS_FULL;
  return `${d.getDate()} ${months[d.getMonth()]}`;
}

// -------------- Weight-unit conversions --------------
// Storage is always in kg. Users can view/edit in "kg" or "lb"; helpers below convert on the fly.
export const KG_TO_LB = 2.20462262185;
export const kgToDisplay = (kg, unit) => (kg == null ? null : (unit === "lb" ? kg * KG_TO_LB : kg));
export const displayToKg = (v, unit) => (v == null || v === "" ? null : (unit === "lb" ? Number(v) / KG_TO_LB : Number(v)));
export const unitLabel = (unit) => (unit === "lb" ? "رطل" : "كجم");
export const unitLabelEn = (unit) => (unit === "lb" ? "lb" : "kg");
